import { Link } from 'react-router-dom';
import { useAuthToken } from '@convex-dev/auth/react';
import { Footer } from './Footer';

interface LegalPageLayoutProps {
  children: React.ReactNode;
  title: string;
  lastUpdated: string;
}

export const LegalPageLayout = ({
  children,
  title,
  lastUpdated,
}: LegalPageLayoutProps) => {
  const token = useAuthToken();
  const isAuthenticated = token !== null;

  const homeLink = isAuthenticated ? '/leads' : '/';

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link
              to={homeLink}
              className="text-2xl font-bold text-gray-900 hover:text-blue-600 transition-colors"
            >
              WinGrow
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          {/* Page Title */}
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              {title}
            </h1>
            <p className="text-sm text-gray-500">
              Last updated: {lastUpdated}
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
            <div className="prose prose-blue max-w-none">
              {children}
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer variant="legal" />
    </div>
  );
};
